import QRCodeStyling from "qr-code-styling";

const DEFAULT_SIZE = 304;
const DEFAULT_DOT_COLOR = "#000000";
const DEFAULT_BG_COLOR = "#FFFFFF";
const DEFAULT_IMAGE_SIZE = 0.24;
const DEFAULT_IMAGE_MARGIN = 8;

function resolveBackgroundColor(value) {
  if (!value || value === "transparent") return "transparent";
  return value;
}

function buildQrOptions({
  link,
  size = DEFAULT_SIZE,
  color = DEFAULT_DOT_COLOR,
  background = DEFAULT_BG_COLOR,
  image,
  imageSize = DEFAULT_IMAGE_SIZE,
  type = "svg",
}) {
  return {
    width: size,
    height: size,
    type,
    data: link,
    image: image || undefined,
    margin: 10,
    qrOptions: {
      errorCorrectionLevel: "H",
    },
    dotsOptions: {
      color,
      type: "rounded",
    },
    cornersSquareOptions: {
      color,
      type: "extra-rounded",
    },
    cornersDotOptions: {
      color,
      type: "dot",
    },
    backgroundOptions: {
      color: resolveBackgroundColor(background),
    },
    imageOptions: {
      crossOrigin: "anonymous",
      margin: DEFAULT_IMAGE_MARGIN,
      imageSize,
      hideBackgroundDots: true,
    },
  };
}

function buildQrCode(node) {
  const link = node.dataset.qrLink;
  if (!link) return;

  const size = parseInt(node.dataset.qrSize, 10) || DEFAULT_SIZE;
  const dotColor = node.dataset.qrColor || DEFAULT_DOT_COLOR;
  const backgroundColor = node.dataset.qrBackground || DEFAULT_BG_COLOR;
  const logoSrc = node.dataset.qrLogo;
  const embedLogo = node.dataset.qrEmbedLogo === "true";
  const fallback = node.querySelector(".qr-code-fallback");
  const logoOverlay = node.querySelector(".qr-code-logo");
  node.classList.remove("has-qr");
  node.innerHTML = "";

  const qrCode = new QRCodeStyling(
    buildQrOptions({
      link,
      size,
      color: dotColor,
      background: backgroundColor,
      image: embedLogo ? logoSrc : undefined,
    })
  );

  qrCode.append(node);
  qrCode.update({ data: link });
  node.classList.add("has-qr");
  node._visQrCode = qrCode;

  if (fallback) node.appendChild(fallback);
  if (logoOverlay && !embedLogo) node.appendChild(logoOverlay);
}

function setupQrCodes() {
  const nodes = document.querySelectorAll("[data-qr-code]");
  nodes.forEach(buildQrCode);
}

async function downloadVisQrCode({
  link,
  filename = "vis-qr-code",
  size = 1024,
  color = DEFAULT_DOT_COLOR,
  background = "transparent",
  image,
  imageSize = DEFAULT_IMAGE_SIZE,
  extension = "png",
}) {
  if (!link) throw new Error("A URL is required to generate a QR code.");

  const qrCode = new QRCodeStyling(
    buildQrOptions({
      link,
      size,
      color,
      background,
      image,
      imageSize,
      type: "canvas",
    })
  );

  await qrCode.download({ name: filename, extension });
}

document.addEventListener("turbolinks:load", setupQrCodes);

// Expose for dynamically mounted Alpine/Vue islands (e.g. coach dashboard).
window.setupVisQrCodes = setupQrCodes;
window.downloadVisQrCode = downloadVisQrCode;
